<template>
    <hts-map
        ref="map"
        :minus-height="minusHeight"
        @update-directions="updateDirections">
        <template #top>
            <slot name="top" />
        </template>
        <template #bottom>
            <slot name="bottom" />
        </template>
    </hts-map>
</template>

<script lang="ts" setup>
const { library } = $store()
const props = defineProps({
  mapStyle: {
    type: String,
    default: ''
  },
  centerPosition: Object as PropType<any>,
  centerMarker: Boolean,
  routeDraw: {
    type: Object,
    default: null
  },
  routeActual: {
    type: Object,
    default: null
  },
  routeEstimate: {
    type: Object,
    default: null
  },
  vehicleActual: {
    type: Object,
    default: null
  },
  route: {
    type: Object,
    default: null
  },
  latLngLocationRoutes: {
    type: Array
  },
  showLocation: {
    type: Boolean
  },
  minusHeight: {
    type: Number,
    default: 0
  }
})

const emits = defineEmits(['click', 'clickMarker', 'updateDirections'])

const { centerPosition, centerMarker, route, routeDraw, routeActual, routeEstimate, vehicleActual, showLocation, latLngLocationRoutes } = toRefs(props)
const map: any = ref(null)
const nodeList = computed(() => {
  return library.locations
})

onMounted(() => {
  map.value?.ready().then(() => {
    removeAdvanceMarkers()
  })

  if (showLocation.value) {
    // vị trí hệ thống
    renderNodeList()
  } else {
    // ví trí điểm của tuyến
    renderNodeListInRoute()
  }

  // chặng
  renderRouteDraw()
  renderRouteDrawActual()
  renderRouteDrawEstimate()
  renderDirectionMarkers()
  renderVehicleActuaMarkers()
})

// watch(
//   () => centerMarker.value,
//   () => {
//
//   },
//   { deep: true }
// )

watch(
  () => centerPosition?.value,
  (val: Object) => {
    map.value &&
      map.value.ready().then(() => {
        if (centerPosition?.value) {
          map.value.removeMarkers()
          map.value.createMarker(val as google.maps.LatLng | google.maps.LatLngLiteral)
        }
      })
  },
  { deep: true }
)

watch(
  () => [routeDraw.value, routeActual.value, routeEstimate.value],
  () => {
    map.value?.clearDirections()
    map.value?.clearPolyline()
    renderRouteDraw()
    renderRouteDrawActual()
    renderRouteDrawEstimate()
  },
  { deep: true }
)

watch(
  () => latLngLocationRoutes?.value,
  (val: any) => {
    if (!showLocation.value) {
      renderNodeListInRoute()
    }
  },
  { deep: true }
)

watch(
  () => showLocation.value,
  (val: any) => {
    if (!val) {
      renderNodeListInRoute()
      return
    }
    renderNodeList()
  },
  { deep: true }
)

watch(
  () => route.value,
  () => {
    renderDirectionMarkers()
  },
  { deep: true }
)

const renderNodeList = (latLngs?: { [key: string]: any }[]) => {
  if (!map.value) {
    return
  }

  map.value.ready().then(() => {
    nodeList.value.forEach(async (node: any) => {
      const lat = parseFloat(node.lat)
      const lng = parseFloat(node.lng)
      const id = node._id

      let draw = false
      if (latLngs && Array.isArray(latLngs) && latLngs.length) {
        for (let i = 0; i < latLngs.length; i++) {
          const sLat = parseFloat(latLngs[i]?.lat?.toString())
          const sLng = parseFloat(latLngs[i]?.lng?.toString())
          const sId = latLngs[i]?.nodeId

          if (lat === sLat && sLng === lng) {
            draw = true
          }

          if (sId && id === sId) {
            draw = true
          }
        }
      } else {
        draw = true
      }

      if (!draw) {
        return
      }
      const innerHtml = node.newLocation
        ? `
<div><?xml version="1.0" encoding="iso-8859-1"?>
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="currentColor" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
 viewBox="0 0 34.398 34.398" xml:space="preserve">
<g>
<g id="c28_geolocalization">
  <path d="M17.202,0C10.749,0,5.515,5.197,5.515,11.607c0,3.281,3.218,9.156,3.218,9.156l8.039,13.635l8.386-13.477
    c0,0,3.726-5.605,3.726-9.314C28.883,5.197,23.653,0,17.202,0z M17.147,18.002c-3.695,0-6.688-2.994-6.688-6.693
    c0-3.693,2.993-6.686,6.688-6.686c3.693,0,6.69,2.992,6.69,6.686C23.837,15.008,20.84,18.002,17.147,18.002z"/>
  <polygon points="18.539,7.233 15.898,7.233 15.898,10.242 12.823,10.242 12.823,12.887 15.898,12.887 15.898,15.985
    18.539,15.985 18.539,12.887 21.576,12.887 21.576,10.242 18.539,10.242 		"/>
</g>
<g id="Capa_1_146_">
</g>
</g>
</svg></div>`
        : `<div><svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 256 256" xml:space="preserve">
<defs>
</defs>
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
<path d="M 45 0 C 27.395 0 13.123 14.272 13.123 31.877 c 0 7.86 2.858 15.043 7.573 20.6 L 45 81.101 l 24.304 -28.624 c 4.716 -5.558 7.573 -12.741 7.573 -20.6 C 76.877 14.272 62.605 0 45 0 z M 45 43.889 c -7.24 0 -13.11 -5.869 -13.11 -13.11 c 0 -7.24 5.869 -13.11 13.11 -13.11 s 13.11 5.869 13.11 13.11 C 58.11 38.02 52.24 43.889 45 43.889 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
<path d="M 58.958 71.559 L 45 82.839 L 31.057 71.556 c -9.329 1.65 -15.682 4.901 -15.682 8.645 c 0 5.412 13.263 9.8 29.625 9.8 c 16.361 0 29.625 -4.388 29.625 -9.8 C 74.625 76.458 68.278 73.209 58.958 71.559 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
</g>
</svg></div>`
      const htmlContent = document.createElement('div')
      htmlContent.className = 'hts-marker text-blue-500' + (node.className || '')
      const text = document.createElement('span')
      const icon = document.createElement('img')
      htmlContent.innerHTML = innerHtml
      text.textContent = node.locationName || $t('labels.unknown')
      htmlContent.appendChild(icon)
      htmlContent.appendChild(text)
      const marker = await map.value.createAdvanceMarker(
        {
          lat,
          lng
        } as google.maps.LatLng | google.maps.LatLngLiteral,
        htmlContent
      )
      marker.addListener('click', () => {
        emits('clickMarker', node)
        map.value.hideInfoWindow()
        map.value.hideClickPositionMarker()
      })
    })
  })
}

const renderNodeListInRoute = (latLngs?: google.maps.LatLngLiteral[]) => {
  removeAdvanceMarkers()
  renderNodeList((latLngs as { [key: string]: any }[]) || latLngLocationRoutes?.value || undefined)
}

const removeAdvanceMarkers = () => {
  map.value && map.value.removeAdvanceMarkers()
}

// vẽ tuyến & polyline
const renderRoute = (data: { [key: string]: any }) => {
  if (!data) {
    return
  }

  if (!map.value) {
    return
  }

  const { routes, options } = data || ({} as any)

  map.value?.ready().then(() => {
    routes?.forEach((item: any) => {
      const { originData, destinationData, data } = item

      const overViewPolyLine = data?.overViewPolyLine || null

      if (!overViewPolyLine) {
        map.value.drawDirection(originData, destinationData, 'DRIVING', [], {
          multiple: !!options?.multiple,
          polylineStyle: options?.polylineStyle,
          startMarker: !!options?.startMarker,
          data
        })
      } else {
        const decodedPath = Array.isArray(overViewPolyLine) ? overViewPolyLine : google.maps.geometry.encoding.decodePath(overViewPolyLine)
        map.value.drawPolyline(decodedPath, {
          polylineStyle: options?.polylineStyle
        })
      }
    })
  })
}

const renderRouteDraw = $lodash.debounce(() => {
  renderRoute(routeDraw.value)
}, 100)

const renderRouteDrawActual = $lodash.debounce(() => {
  renderRoute(routeActual.value)
}, 100)

const renderRouteDrawEstimate = $lodash.debounce(() => {
  renderRoute(routeEstimate.value)
}, 100)

const renderVehicleActuaMarkers = $lodash.debounce(() => {
  if (!vehicleActual.value) {
    map.value &&
      map.value.ready().then(() => {
        const innerHtml = `<div><svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 256 256" xml:space="preserve">
<defs>
</defs>
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
<path d="M 45 0 C 27.395 0 13.123 14.272 13.123 31.877 c 0 7.86 2.858 15.043 7.573 20.6 L 45 81.101 l 24.304 -28.624 c 4.716 -5.558 7.573 -12.741 7.573 -20.6 C 76.877 14.272 62.605 0 45 0 z M 45 43.889 c -7.24 0 -13.11 -5.869 -13.11 -13.11 c 0 -7.24 5.869 -13.11 13.11 -13.11 s 13.11 5.869 13.11 13.11 C 58.11 38.02 52.24 43.889 45 43.889 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
<path d="M 58.958 71.559 L 45 82.839 L 31.057 71.556 c -9.329 1.65 -15.682 4.901 -15.682 8.645 c 0 5.412 13.263 9.8 29.625 9.8 c 16.361 0 29.625 -4.388 29.625 -9.8 C 74.625 76.458 68.278 73.209 58.958 71.559 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: currentColor; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
</g>
</svg></div>`
        const htmlContent = document.createElement('div')
        htmlContent.className = 'hts-marker text-blue-500'
        const text = document.createElement('span')
        const icon = document.createElement('img')
        htmlContent.innerHTML = innerHtml
        text.textContent = $t('labels.unknown')
        htmlContent.appendChild(icon)
        htmlContent.appendChild(text)

        map.value.createAdvanceMarker(vehicleActual.value, htmlContent)
      })
  }
}, 100)

// vẻ markers trong tuyến
const renderDirectionMarkers = $lodash.debounce(() => {
  const { originData, destinationData, waypointsData, options } = route.value

  map.value?.ready().then(() => {
    map.value.generateDirectionMarkers(
      {
        location: originData,
        name: options?.originLocationName
      },
      {
        location: destinationData,
        name: options?.destinationLocationName
      },
      waypointsData,
      {
        sameOriginDestination: !!options?.sameOriginDestination,
        renderMarkerByIndexNumber: !!options?.renderMarkerByIndexNumber
      }
    )
  })
}, 100)

const resetMap = () => {
  map.value?.ready().then(() => {
    map.value?.resetMap()
  })
}

const clearDirections = () => {
  map.value?.ready().then(() => {
    map.value?.clearDirections()
  })
}

const updateDirections = (data: any) => {
  emits('updateDirections', data)
}

defineExpose({ renderNodeList, removeAdvanceMarkers, renderNodeListInRoute, resetMap, clearDirections })
</script>
